import React from 'react';
import { css } from '@emotion/react';
import { conf } from '../../../domain/services/configService';
import { theme } from '../../../domain/theme';
import { SmartLink } from '../../SmartLink';
import { DrupalEdit } from '../molecules/DrupalEdit';

const hideOnMobile = css`
  display: none;
  ${theme.mq.tablet} {
    display: block;
  }
`;

const hideOnTablet = css`
  ${theme.mq.tablet} {
    display: none;
  }
  ${theme.mq.small_desktop} {
    display: block;
  }
`;

const styles = {
  container: css`
    height: 31px;
    max-height: 31px;
    list-style-type: none;
    background: #000;
    width: 100%;
    padding: ${theme.spacing.parse('$xs2 $xs')};
    ${theme.mq.tablet} {
      padding: ${theme.spacing.parse('$xs2 $s')};
    }
    margin: 0;
    overflow: hidden;
  `,
  li: link => css`
    display: block;
    float: left;
    color: #fff;
    margin: ${theme.spacing.parse('0 $base 0 0')};
    padding: 0;
    line-height: 0;
    ${link.hideOnMobile === '1' ? hideOnMobile : undefined}
    ${link.hideOnTablet === '1' ? hideOnTablet : undefined}
    &:last-child {
      float: right;
      margin: 0;
    }
  `,
  a: css`
    ${theme.font.family('boldWeb')};
    font-weight: 400;
    letter-spacing: 3px;
    line-height: 1.5;
    font-style: normal;
    color: #fff;
    font-size: ${theme.font.size('xs3')};
    text-transform: uppercase;
    &:hover {
      color: #ccc;
    }
  `
};

export const GlobalNavigation = () => {
  return (
    <nav>
      <ul css={styles.container}>
        {conf.menus.menuGlobalNavigation.map((link, index) => (
          <li
            css={styles.li(link)}
            className={link.containerClass}
            key={link.title}
          >
            <SmartLink
              css={styles.a}
              to={link.url}
              target={link.target}
              className={link.class}
              dataLayerClickEvent={
                link.dataLayerEvent
                  ? {
                      event: link.dataLayerEvent,
                      location: 'Top'
                    }
                  : undefined
              }
            >
              {link.title}
            </SmartLink>
            {index === conf.menus.menuGlobalNavigation.length - 1 && (
              <DrupalEdit
                entityType="menu"
                entityId="natgeo-global-nav"
                color="white"
              />
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
};
